<!--
@component

A simple list menu with items, usually appears on click.
```svelte
<ContextMenu>
  <ContextMenuItem icon="plus" variant="danger" label="click me!" />
  <ContextMenuSeparator />
</ContextMenu>
```
-->
<svelte:options immutable />

<script lang="ts">
import type { ClassValue } from 'svelte/elements';

/** ID attribute of the menu element. */
export let id: string;

/** Accessible label of the menu. */
export let label: string | undefined = undefined;

/** ID of the element that labels the menu. */
export let labelledBy: string | undefined = undefined;

/** Additional CSS classes to pass to the menu. */
let extraClasses: ClassValue = '';
export { extraClasses as cx };
</script>

<div
  {id}
  aria-label={label}
  aria-labelledby={labelledBy}
  role="menu"
  class={[
    'border-medium border bg-white py-1 shadow-sm filter-none',
    extraClasses,
  ]}
>
  <slot />
</div>
